import { cloneDeep } from 'lodash-es'
import { v4 as uuidv4 } from 'uuid'

import { ReportBuilderAPI } from 'src/api'
import { NotifyService } from 'src/services'

const initialState = {
  isEditMode: false,
  reportView: {},
}

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  mutations: {
    RESET(state) {
      const clonedInitialState = cloneDeep(initialState)

      for (const key in clonedInitialState) {
        if (Object.hasOwnProperty.call(clonedInitialState, key)) {
          state[key] = clonedInitialState[key]
        }
      }
    },
    SET_EDIT_MODE(state, payload) {
      state.isEditMode = payload
    },
    SET_REPORT_TITLE(state, payload) {
      state.reportView.title = payload
    },
    SET_REPORT_PRIVATE(state, payload) {
      state.reportView.isPrivate = payload
    },
    SET_REPORT_DRAFT(state, payload) {
      state.reportView.isDraft = payload
    },
    ADD_REPORT_PAGE(state) {
      state.reportView.reportSettings.pages.push({
        id: uuidv4(),
        pageTitle: '',
        description: '',
        gridItems: [],
      })
    },
    DELETE_REPORT_PAGE(state, payload) {
      const { reportSettings } = state.reportView

      reportSettings.pages = reportSettings.pages.filter((_, index) => index !== payload)
    },
    MOVE_REPORT_PAGE(state, { index, direction }) {
      const { reportSettings } = state.reportView
      const [page] = reportSettings.pages.splice(index, 1)

      if (direction === 'up') {
        reportSettings.pages.splice(index - 1, 0, page)
      } else {
        reportSettings.pages.splice(index + 1, 0, page)
      }
    },
    EDIT_REPORT_PAGE(state, { index, mergeData = {} }) {
      Object.assign(state.reportView.reportSettings.pages[index], mergeData)
    },
    ADD_REPORT_GRID_ITEM(state, { pageIndex, gridItem }) {
      state.reportView.reportSettings.pages[pageIndex].gridItems.push(gridItem)
    },
    EDIT_REPORT_GRID_ITEM(state, { pageIndex, row, col, mergeData = {} }) {
      const gridItem = state.reportView.reportSettings.pages[pageIndex].gridItems.find(
        (item) => item.row === row && item.col === col
      )
      Object.assign(gridItem, mergeData)
    },
    DELETE_REPORT_GRID_ITEM(state, { pageIndex, row, col }) {
      const page = state.reportView.reportSettings.pages[pageIndex]

      page.gridItems = page.gridItems.filter((item) => item.row !== row || item.col !== col)
    },
    SET_REPORT_VIEW(state, payload) {
      state.reportView = payload
    },
  },
  actions: {
    async updateReport({ state }, payload) {
      const { id, title, reportSettings, isPrivate, isDraft, dealerGroupId } =
        payload ?? state.reportView
      const clonedReportSettings = cloneDeep(reportSettings)

      // Remove id, which created for prevent rerendering
      for (const page of clonedReportSettings.pages) {
        delete page.id
      }

      await ReportBuilderAPI.updateReport({
        id,
        isPrivate,
        isDraft,
        title,
        dealerGroupId,
        reportSettings: clonedReportSettings,
      })
      NotifyService.create({
        type: 'positive',
        message: 'Report saved successfully',
      })
    },
  },
}
